// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ggsi ggs-html-player{display:block!important}`, "",{"version":3,"sources":["webpack://./app/gallery-v2/src/ggs-html-player/ggs-html-player.directive.less"],"names":[],"mappings":"AAAA,sBAEI,uBAAJ","sourcesContent":[".ggsi {\n  ggs-html-player {\n    display: block;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
